import FilterLogicModal from "../../components/modal/campaignListModals/filterLogicModal/filterLogicModal";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useRef } from "react";
import CalenderComponent from "../../components/calender/Calender";
import closeIcon from "../../assets/icons/close_icon.png";
import { useGlobalContext } from "../../context/global";
import selectSideIcon from "../../assets/icons/select-btn-side-grey-icon.png";
import CalenderIconForCampaignList from "../../assets/icons/calender-icon-for-campaignlist.svg";
import Chart from "../../components/Reports/Chart";
import cubejs from "@cubejs-client/core";
import useToken from "../../helper/Reports/useToken";
import ReportFilters from "../../components/Reports/Filters";
import SectionTitle from "../../components/sectionTitle";
import previousDays from "../../helper/Reports/common";
import Loader from "../../components/loader";
import useInitialLoad from "../../hooks/useInitialLoad";
import Breadcrumb from '../../components/Breadcrumb/ReportsBreadCrumb';
import Canvas from '../../helper/Screenshot/canvas'
import downloadIcon from "../../assets/svgs/download.svg";
import {formatPieChartData,dataQueryParser,createQueryURL,objectoFiltering,getSearchParamsObject} from "../../components/Reports/Components/utils";
import {useSearchParams} from "react-router-dom";
import { keyExtractor } from "../../helper/widget";

const TargetingReport = (props) => {
  const { calendarDate, setCalendarDate, setDateDifference,applyCalendar, dateDifference,multiCalendarDate } = useGlobalContext();
  const dashboardSideBarVisibiltyState = useSelector(
    (state) => state.dashboardData.dashboardSideBarVisibiltyState
  );
  const [showCustomDateBox, setShowCustomDateBox] = useState(false);
  const [initialLoad,setInitialLoad] = useInitialLoad()
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [token, refresh] = useToken("");
  const { cubeToken, setCubeToken } = useGlobalContext();
  const { clientAccountId } = useGlobalContext();
  const [searchParams,setSearchParams] = useSearchParams({});
  const [tableView, setTableView] = useState("table");
  const [showFilters, setShowFilters] = useState(true)
  const cubejsApi = cubejs(cubeToken, {apiUrl: process.env.REACT_APP_CUBE_JS_URL});
  const [isLoaderVisible, setIsLoaderVisible] = useState(false);
  const formatDate = (date) => {
    const offset = date.getTimezoneOffset();
    date = new Date(date.getTime() - offset * 60 * 1000);
    return date.toISOString().split("T")[0].toString();
  };
  const allParams = new URLSearchParams(window.location.search);
  const paramsObject = getSearchParamsObject(allParams);
  const previousFiltering = objectoFiltering(paramsObject,"AmazonTargetTable")
  const viewType = allParams.get('viewtype') ?? 'Performance View';
  const [currentViewType, setCurrentViewType] = useState(viewType);
  const isComparisonView = currentViewType === 'Comparison View';
  let startDate = formatDate(multiCalendarDate.selection1.startDate);
  let endDate = formatDate(multiCalendarDate.selection1.endDate);
  let startDatePrevious = formatDate(
        multiCalendarDate.selection2.startDate
      );
  let endDatePrevious = formatDate(multiCalendarDate.selection2.endDate);
  
  const cubeQueryTimeDimensionsFormatted = !isComparisonView ? [{dimension:"AmazonTargetTable.date",dateRange: [
    formatDate(calendarDate[0].startDate),
    formatDate(calendarDate[0].endDate),
  ]}] : [{dimension:"AmazonTargetTable.date",compareDateRange:[
    [startDate, endDate],
    [startDatePrevious, endDatePrevious],
  ]}]
  const [drrView, setDrrView] = useState("")
  const [summaryTotal, setSummaryTotal] = useState({})
  const [summaryComparisonTotal, setSummaryComparisonTotal] = useState({})
  const [paginationLimit, setPaginationLimit] = useState(250);
  const [paginationOffset, setPaginationOffset] = useState(0);
  const [paginationResultSet, setPaginationResultSet] = useState({});

  const [campaignType, setCampaignType] = useState([]);
  const [campaignFormat, setCampaignFormat] = useState([]);
  const [targetingType, setTargetingType] = useState([]);
  const [productSet, setProductSet] = useState([]);
  const [targetStatus, setTargetStatus] = useState([]);
  const [portfolioName, setPortfolioName] = useState([]);
  const [adyogiMatchtype, setAdyogiMatchtype] = useState([]);
  const [childrenOne, setChildrenOne] = useState({});
  const [childDataIndex, setChildDataIndex] = useState(0);

  const [cubeQueryMeasure, setCubeQueryMeasure] = useState([
    "AmazonTargetTable.cost",
    "AmazonTargetTable.costDRR",
    "AmazonTargetTable.impressions",
    "AmazonTargetTable.impressionsDRR",
    "AmazonTargetTable.clicks",
    "AmazonTargetTable.clicksDRR",
    "AmazonTargetTable.ctr",
    "AmazonTargetTable.ctrDRR",
    "AmazonTargetTable.cpc",
    "AmazonTargetTable.cpcDRR",
    "AmazonTargetTable.cpm",
    "AmazonTargetTable.cpmDRR",
    "AmazonTargetTable.conversions14d",
    "AmazonTargetTable.conversions14dDRR",
    "AmazonTargetTable.conversion_rate",
    "AmazonTargetTable.conversion_rateDRR",
    "AmazonTargetTable.sales14d",
    "AmazonTargetTable.sales14dDRR",
    "AmazonTargetTable.average_order_value",
    "AmazonTargetTable.average_order_valueDRR",
    "AmazonTargetTable.acos",
    "AmazonTargetTable.acosDRR",
    "AmazonTargetTable.roas",
    "AmazonTargetTable.roasDRR",
  ]);
  const [cubeQueryOrder, setCubeQueryOrder] = useState([
    ["AmazonTargetTable.cost", "desc"],
    ["AmazonTargetTable.targetingDimension", "desc"],
  ]);

  const [cubeChildRowQueryOrder, setCubeChildRowQueryOrder] = useState([
    ["AmazonTargetTable.cost", "desc"],
  ]);

  const [cubeQueryDimensions, setCubeQueryDimensions] = useState([
    "AmazonTargetTable.targetingDimension",
  ]);

  const [cubeChildRowsQueryDimensions, setCubeChildRowsQueryDimensions] = useState([
    "AmazonTargetTable.targetingDimension",
    "AmazonTargetTable.matchTypeDimension"
  ]);

  const [cubeQueryTimeDimensions, setCubeQueryTimeDimensions] = useState(cubeQueryTimeDimensionsFormatted);
  const [cubeQueryFilters, setCubeQueryFilters] = useState([
    {
      member: "AmazonTargetTable.profileId",
      operator: "equals",
      values: [clientAccountId],
    },
    ...previousFiltering
  ]);
  const [cubeChildRowsQueryFilters, setCubeChildRowsQueryFilters] = useState([
    {
      member: "AmazonTargetTable.profileId",
      operator: "equals",
      values: [clientAccountId],
    },
    ...previousFiltering
  ]);
  const enabledfilters = ["Campaign Type","Campaign Format","Targeting Type","Product Set","Target Status","Portfolio Name","Adyogi Targeting Type"]

  const [resultSet, setResultSet] = useState({});
  const [chartFilters, setChartFilters] = useState({
    spend:"cost",
    revenue:"sales14d"
  })
  var spendResultSet = formatPieChartData(resultSet, chartFilters.spend,"AmazonTargetTable", "targetingDimension");
  var revenueResultSet = formatPieChartData(resultSet, chartFilters.revenue,"AmazonTargetTable", "targetingDimension");
  const getTargetingMemberKey = (type) => {
    const mapper = {
      targeting: "targetingDimension",
      campaignName: "campaignNameDimension",
      adGroupName: "adGroupNameDimension",
      keywordType: "keywordTypeDimension",
      expression: "expressionDimension",
      campaignFormat: "campaignFormatDimension",
      campaignType: "campaignTypeDimension",
      targetingType: "targetingTypeDimension",
      productSet: "productSetDimension",
      targetStatus: "targetStatusDimension",
      campaignStatus: "campaignStatusDimension",
      portfolioName: "portfolioNameDimension",
      matchType: "matchTypeDimension",
      adyogiTargetingType: "adyogiTargetingTypeDimension",
      portfolioId: "portfolioIdDimension",
      targetAsin: "targetAsinDimension",
      asin: "asinDimension",
      itemName: "itemNameDimension",
      week: "weekDimension",
    };
    return mapper[type] ?? type;
  };

  const filterModalInCampaignListVisibilty = useSelector(
    (state) => state.campaignListData.filterModalInCampaignListVisibilty
  );


  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    // Set state variables from url
    if(queryParams.get('start') &&  queryParams.get('end')) {
        setDate(queryParams.get('start'), queryParams.get('end'));
    }
  }, []);

  const setDate = (currentDate, previousDate) => {
    const dates = {
      startDate: new Date(currentDate),
      endDate: new Date(previousDate),
      key: "selection",
    };
    setDateDifference("Custom");
    setCalendarDate([dates]);
    setCubeQueryTimeDimensions((prev) => {
      let data = [...prev];
      data[0]["dateRange"] = [
        formatDate(dates.startDate),
        formatDate(dates.endDate),
      ];
      return data;
    });
  };

  useEffect(() => {
    if(currentViewType !== "Comparison View") {
        const startDate = formatDate(calendarDate[0].startDate);
        const endDate = formatDate(calendarDate[0].endDate);
        if (startDate !== cubeQueryTimeDimensions[0]["dateRange"][0] || endDate !== cubeQueryTimeDimensions[0]["dateRange"][1]) {
            setIsLoaderVisible(true)
            setCubeQueryTimeDimensions((prev) => {
                let data = [...prev];
                data[0]["dateRange"] = [startDate, endDate];
                return data;
            });
        }
    } 
}, [applyCalendar]);

useEffect(() => {
    if(currentViewType === "Comparison View") {
        let startDate = formatDate(multiCalendarDate.selection1.startDate);
        let endDate = formatDate(multiCalendarDate.selection1.endDate);
        let startDatePrevious = formatDate(multiCalendarDate.selection2.startDate);
        let endDatePrevious = formatDate(multiCalendarDate.selection2.endDate);
        let apiDateRange = cubeQueryTimeDimensions[0]["compareDateRange"]
        if (startDate !== apiDateRange[0][0] || endDate !== apiDateRange[0][1] || startDatePrevious !== apiDateRange[1][0] || endDatePrevious !== apiDateRange[1][1]) {
            setIsLoaderVisible(true)
            setCubeQueryTimeDimensions((prev) => {
                let data = [...prev];
                data[0]["compareDateRange"] = [[startDate, endDate], [startDatePrevious, endDatePrevious]];
                return data;
            });
        } 
    }
},[applyCalendar])

  useEffect(() => {
    //table data
    if (cubeToken) {
      cubejsApi
        .load(
          {
            measures: cubeQueryMeasure,
            order: cubeQueryOrder,
            dimensions: cubeQueryDimensions,
            filters: cubeQueryFilters,
            timeDimensions: cubeQueryTimeDimensions,
            limit: paginationLimit,
            offset: (paginationOffset*paginationLimit), 
            total: true,
          },
          {
            headers: {
              "Access-Control-Allow-Origin": true,
            },
          }
        )
        .then((resultSet) => {
          if(paginationOffset>0) {
            setPaginationResultSet(resultSet)
          } else {
            setResultSet(resultSet);
          }
          setIsLoaderVisible(false)
          setInitialLoad(false)
          if(currentViewType === 'Comparison View') {
            setTableView("ComparisonTable")
          } else {
              setTableView("table")
          }
        }).catch((error) => {
          if(error.message === 'Invalid token') {
              setCubeToken(false)
              localStorage.setItem("cubeToken", null);
              refresh()
          }
        });
    }
  }, [cubeQueryFilters,cubeQueryTimeDimensions, cubeToken, cubeQueryOrder, paginationOffset]);


  
  useEffect(() => {
    if(cubeToken) {
      cubejsApi.load({
        measures: cubeQueryMeasure,
        order: cubeQueryOrder,
        filters: cubeQueryFilters,
        timeDimensions: cubeQueryTimeDimensions,
      },{
        headers: {"Access-Control-Allow-Origin": true},
      }
    ).then((result) => {
      if(result?.loadResponse?.results[0]?.data[0]) {
        const modifiedObject = {};
        let originalObject = result?.loadResponse?.results[0]?.data[0]
        Object.keys(originalObject).forEach(key => {
          const newKey = keyExtractor(key);
          modifiedObject[newKey] = originalObject[key];
        });
        setSummaryTotal(modifiedObject)
      }
      if(result?.loadResponse?.results[1]?.data[0]) {
        const modifiedObject = {};
        let originalObject = result?.loadResponse?.results[1]?.data[0]
        Object.keys(originalObject).forEach(key => {
          const newKey = keyExtractor(key);
          modifiedObject[newKey] = originalObject[key];
        });
        setSummaryComparisonTotal(modifiedObject)
      }
    }).catch((error) => {
      if(error.message === 'Invalid token') {
          setCubeToken(false)
          localStorage.setItem("cubeToken", null);
          refresh()
      }
    });;
    }
  },[cubeQueryFilters])

  const filterCampaigns = (e, type) => {
    let operator = "equals";
    if(type ==='adyogiTargetingType') {
      operator = "contains"
    }
    setChildrenOne({})
    setPaginationOffset(0)
    const memberKey = getTargetingMemberKey(type);
    const parsedQueryFilters = dataQueryParser(
      JSON.parse(JSON.stringify(cubeQueryFilters)),
      e,
      memberKey,
      "AmazonTargetTable"
    );
    const parsedParams = createQueryURL(parsedQueryFilters);
    parsedParams['viewtype'] = currentViewType
    const previousParams = new URLSearchParams(window.location.search)
    if(previousParams.get('metricViewType')) {
      parsedParams['metricViewType'] = previousParams.get('metricViewType')
    }
    setSearchParams(parsedParams)
    setIsLoaderVisible(true)
    setCubeQueryFilters((prev) => {
      let data = [...prev];
      data.forEach((x, i) => {
        if (x.member === "AmazonTargetTable."+memberKey) {
          data.splice(i, 1);
        }
      });
      if (e.length>0) {
        data.push({
          member: "AmazonTargetTable."+memberKey,
          operator: operator,
          values: e,
        });
      }
      return data;
    });
    setCubeChildRowsQueryFilters((prev) => {
      let data = [...prev];
      data.forEach((x, i) => {
        if (x.member === "AmazonTargetTable."+memberKey) {
          data.splice(i, 1);
        }
      });
      if (e.length>0) {
        data.push({
          member: "AmazonTargetTable."+memberKey,
          operator: "equals",
          values: e,
        });
      }
      return data;
    });
    if (type === "campaignType") {
      setCampaignType(e);
    } else if (type === "campaignFormat") {
      setCampaignFormat(e);
    } else if (type === "targetingType") {
      setTargetingType(e);
    } else if (type === "productSet") {
      setProductSet(e);
    } else if (type === "targetStatus") {
        setTargetStatus(e);
    } else if (type === "portfolioName") {
      setPortfolioName(e);
    } else if (type === "adyogiMatchtype") {
      setAdyogiMatchtype(e);
    }
  };

  const expendChange = (data, type, index) => {
      let prevData = [...cubeChildRowsQueryFilters]
      prevData.forEach((x, i) => {
        if (x.member === 'AmazonTargetTable.targetingDimension') {
          prevData.splice(i, 1);
        }
      });
      prevData.push({
          member: 'AmazonTargetTable.targetingDimension',
          operator: "equals",
          values: [data],
        });

      setChildDataIndex(data)
      setCubeChildRowsQueryFilters(prevData);
  };

  useEffect(() => {
    let getdata = false
    let prevData = [...cubeChildRowsQueryFilters]
    prevData.forEach((x, i) => {
        if (x.member === 'AmazonTargetTable.targetingDimension') {
            getdata = true
        }
      });
      if(getdata) {
        cubejsApi.load({
            measures: cubeQueryMeasure,
            order: cubeChildRowQueryOrder,
            dimensions: cubeChildRowsQueryDimensions,
            filters: cubeChildRowsQueryFilters,
            timeDimensions: cubeQueryTimeDimensions,
            limit: 5000,
          },{
            headers: {"Access-Control-Allow-Origin": true,},
          }
        ).then((childResultSet) => {
          setChildrenOne((prev) => { 
            return {...prev,[childDataIndex]: childResultSet}
          })
        }).catch((error) => {
          if(error.message === 'Invalid token') {
              setCubeToken(false)
              localStorage.setItem("cubeToken", null);
              refresh()
          }
        });
      }
    
  },[cubeChildRowsQueryFilters])

  const calenderIconRefForCampaignlist = useRef(null);

  const closeCalender = (e) => {
    if (
      calenderIconRefForCampaignlist.current &&
      showCustomDateBox &&
      !calenderIconRefForCampaignlist.current.contains(e.target)
    ) {
      setShowCustomDateBox(false);
    }
  };

  const dateInputClickHandler = (e) => {
    setShowCustomDateBox(!showCustomDateBox);
  };

  useEffect(() => {
    document.addEventListener("mousedown", closeCalender);
    return () => {
      // Cleanup the event listener
      document.removeEventListener("mousedown", closeCalender);
    };
  }, [showCustomDateBox]);


  const handleComparisonView = (type) => {
    setChildrenOne({})
    if(type === 'Comparison View') {
        setPaginationOffset(0)
        setCubeQueryTimeDimensions([{
              dimension: "AmazonTargetTable.date",
              compareDateRange: [[startDate, endDate], [startDatePrevious, endDatePrevious]],
            },
          ]);
          setIsLoaderVisible(true)
    } else if(type !== 'Comparison View' && currentViewType === 'Comparison View') {
        setPaginationOffset(0)
        setCubeQueryTimeDimensions([{
            dimension: "AmazonTargetTable.date",
            dateRange: [formatDate(calendarDate[0].startDate), formatDate(calendarDate[0].endDate)],
          },
        ]);
        setIsLoaderVisible(true)
    }
    setCurrentViewType(type)
  }

  
 

  const sortData = (key, order) => {
    setPaginationOffset(0)
    setIsLoaderVisible(true)
    setCubeQueryOrder([
      [key, order]
    ]);
  }
  const pagination = (data) => {
    setPaginationOffset(paginationOffset+1)
  }

  useEffect(() => {
    setIsFilterVisible(filterModalInCampaignListVisibilty);
  }, [filterModalInCampaignListVisibilty]);

  function dataFilter(data) {
    setChildrenOne({})
    setIsLoaderVisible(true)
    setPaginationOffset(0)
    const table = "AmazonTargetTable.";
    let tempFilters = [...cubeQueryFilters];
    Object.entries(data).forEach(([key, value]) => {
      tempFilters.forEach((x, i) => {
        if (x.member === `${table}${key}`) {
          tempFilters.splice(i, 1);
        }
      });
      if (value.min) {
        tempFilters.push({
          member: `${table}${key}`,
          operator: 'gte',
          values: [parseFloat(value.min)]
        });
      }
      if (value.max) {
        tempFilters.push({
          member: `${table}${key}`,
          operator: 'lte',
          values: [parseFloat(value.max)]
        });
      }
    })
    setCubeQueryFilters(tempFilters);
    setCubeChildRowsQueryFilters(tempFilters);
  }

  const handleDownload = () => {
    Canvas({ name: 'targeting-report' });
  };

  const handleDrrView = (value, type) => {
    setDrrView(value)
    setChildrenOne({})
      if(value !== 'drr') {
          setChartFilters({spend:"cost",revenue:"sales14d"})
      } else {
          setChartFilters({spend:"costDRR",revenue:"sales14dDRR"})
      }
  };
  function handleSearch(data) {
    setIsLoaderVisible(true)

    let prevData = [...cubeQueryFilters]
      prevData.forEach((x, i) => {
        if (x.member === cubeQueryDimensions[0]) {
          prevData.splice(i, 1);
        }
      });
      if(data.input) {
        prevData.push({
            member: cubeQueryDimensions[0],
            operator: data.select,
            values: [data.input],
          });
      }
      setShowFilters(data)
      setCubeQueryFilters(prevData);
      setCubeChildRowsQueryFilters(prevData);
  }
  return (
    <div
      className={
        dashboardSideBarVisibiltyState
          ? "main-content-container-onopen-mode"
          : "main-content-container-oncolapse-mode"
      }
      id="main-box"
    >
      <Loader visible={initialLoad}></Loader>
      <div style={{marginLeft: "auto"}}>
        <button
          className="date-container date-btn-campaignlist d-none"
          onClick={dateInputClickHandler}
        >
          <div className="d-flex justify-conntent-center">
            <span className="date-btn-text">{dateDifference}</span>
          </div>
          <button className="btn-calender-img-holder">
            <span className="">
              <img
                className="dropdown-img-for-select"
                src={selectSideIcon}
                alt={"SelectSideIcon"}
              ></img>

              <img
                className="calender-icon-for-campaignlist"
                src={CalenderIconForCampaignList}
                alt={"CalendarIcon"}
              ></img>
            </span>
          </button>
        </button>
      </div>

      <div
        ref={calenderIconRefForCampaignlist}
        className={
          showCustomDateBox ? "calender-inclasslist-container" : "hide"
        }
      >
        <CalenderComponent setShowCustomDateBox={setShowCustomDateBox}></CalenderComponent>
        <span className="calender-close-icon-campaignlist">
          <img
            onClick={() => setShowCustomDateBox(false)}
            src={closeIcon}
            alt={"CloseIcon"}
          ></img>
        </span>
      </div>
      
      <Breadcrumb />
      <SectionTitle sectionTitleHeading='Targeting Report'></SectionTitle>
      <div className="d-flex justify-content-between mt-4 mb-4 gap-4 position-relative" id="downloadChart" >
      <div onClick={handleDownload} className="downloadChartWrapper pie" id="downloadChartWrapper">
            <img src={downloadIcon} className="cursor-pointer-global DownloadIcon" alt="overview-settings-tile" />
      </div>
        <div className="w-100 min-h-300 pie-container">
          <h4 className="sub-heading-pie f-20 p-4">Spends</h4>
          <Chart
            type="apexpie"
            resultSet={spendResultSet}
            classes={"marketing-reports"}
            display={"spends"}
          />
        </div>
        <div className="w-100 min-h-300 pie-container">
          <h4 className="sub-heading-pie f-20 p-4">Revenue</h4>
          <Chart
            type="apexpie"
            resultSet={revenueResultSet}
            classes={"marketing-reports"}
            display={"spends"}
          />
        </div>
      </div>

      <ReportFilters handleDropdown={filterCampaigns} enabledfilters={enabledfilters} />

      <div>
        {
          <FilterLogicModal
            filterFor="campaignlist"
            show={isFilterVisible}
          ></FilterLogicModal>
        }
      </div>

      <div className="">
          <Chart
            type={tableView}
            shimmerEffect={isLoaderVisible}
            resultSet={resultSet}
            classes={"sortByApi wraptext marketing-reports"}
            display={'campaign_format'}
            handleChange={expendChange}
            childrenOneData={childrenOne}
            childrenOneHeader={'Match Type'}
            FunnelViews={["Performance View","Funnel View","Comparison View","Custom View"]} handleComparisonView={handleComparisonView} CurrentViewType={currentViewType} page="expendable" dataFilter={dataFilter} drrView={handleDrrView} drrViewType={drrView} handleSearch={handleSearch}
            showFilter={showFilters}
            sortData={sortData}
            pagination={pagination}
            paginationResultSet={paginationResultSet}
            summaryTotal={summaryTotal}
            summaryComparisonTotal={summaryComparisonTotal}
          />
      </div>
    </div>
  );
};

export default TargetingReport;